import { useT } from '@spotify-internal/i18n-core';

export const useProfileProtectionsCopy = () => {
  const t = useT();

  return {
    feedName: t('atlas.labels.feed_name', 'Feed name', 'Label for Feed name'),
    licensorName: t(
      'atlas.labels.licensor_name',
      'Licensor name',
      'Label for Licensor name',
    ),
    productDetails: t(
      'atlas.labels.product_details',
      'Product details',
      'Label for Product details',
    ),
    approvalStatus: t(
      'atlas.labels.approval_status',
      'Approval status',
      'Label for Approval status column header in the Track contributors table',
    ),
    primaryReleaseId: t(
      'atlas.labels.primary_release_id',
      'Primary release ID',
      'Label for Primary release ID',
    ),
    productType: t(
      'atlas.labels.product_type',
      'Product type',
      'Label for Product type',
    ),
    includedMedia: t(
      'atlas.labels.included_media',
      'Included media',
      'Text for Included media label',
    ),
    originalReleaseDate: t(
      'atlas.labels.original_release_date',
      'Original release date',
      'Label for Original release date',
    ),
    copyUri: t(
      'atlas.actions.copy_uri',
      'Copy URI',
      'Text for Copy URI action',
    ),
    noReleasesFound: t(
      'atlas.profile_protections.no_releases_found',
      'No releases found',
      'Empty state title when active filters return no results',
    ),
    noReleasesFoundText: t(
      'atlas.profile_protections.no_releases_found_text',
      'There are no releases that match your filters.',
      'Empty state body when active filters return no results',
    ),
    noReleasesNeedApproval: t(
      'atlas.profile_protections.no_releases_need_approval',
      'No releases need approval',
      'Empty state title when there are no releases at all',
    ),
    noReleasesNeedApprovalText: t(
      'atlas.profile_protections.no_releases_need_approval_text',
      'Any upcoming and recent releases that need approval will appear here for up to 28 days after they are released.',
      'Empty state body when there are no releases at all',
    ),
    noReleasesToShow: t(
      'atlas.profile_protections.no_releases_to_show',
      'No releases to show',
      'Empty state title when there are no releases (extended beta)',
    ),
    noReleasesToShowText: t(
      'atlas.profile_protections.no_releases_to_show_text',
      'Any upcoming and recent releases that need approval or have been approved or declined will appear here for up to 28 days after they are released.',
      'Empty state body when there are no releases (extended beta)',
    ),
    resultsPerPage: t(
      'atlas.table_pagination.results_per_page',
      'Results per page:',
      'Label for dropdown to select how many results per page to show',
    ),
    explicitLyricsAriaLabel: t(
      'atlas.labels.explicit_lyrics',
      'Explicit lyrics',
      'Label for Explicit lyrics. The value will be a boolean, i.e. "Yes" or "No".',
    ),
    filterByApprovalStatus: t(
      'atlas.filter_popover.approval_status_aria_label',
      'Filter by approval status',
      'aria-label for approval status filter popover',
    ),
    filterHelpText: t(
      'atlas.profile_protections.filter_help_text',
      'These are for main artists on a release only.',
      'Help text in the approval status filter popover',
    ),
    filterClear: t(
      'atlas.filter_popover.clear',
      'Clear',
      'Button to clear current filter selection',
    ),
    filterApply: t(
      'atlas.filter_popover.apply',
      'Apply',
      'Button to apply a new filter selection',
    ),
  };
};
